<main id="main-content" class="h-screen flex flex-col p-8 transition-all duration-0">
    <div class="w-full h-full flex flex-col items-center justify-center gap-4">
        <img src="assets/logo.png" alt="nSide Logo" class="w-40">
        <h1 class="text-3xl oswald-font">Page Not Found</h1>
    </div>
</main>